<template>
  <div v-if="!loading">
    <form>
      <v-layout
        row
        wrap
        pt-5
      >
        <v-flex xs12>
          <v-subheader
            class="pl-0"
          >
            Expertné posúdenie - pravdepodobnosť, že posudzovaná osoba sa
            dopustí trestnej činnosti do 2 rokov od prepustenia
          </v-subheader>
          <v-slider
            v-model="form.expertne_posudenie"
            :tick-labels="selects.expertne_posudenie"
            always-dirty
            min="1"
            max="3"
            ticks="always"
            :color="color"
            :readonly="form.closed"
            append-icon="mdi-information-outline"
            @click:append="appendIconCallback('expertne_posudenie')"
          />
        </v-flex>
      </v-layout>

      <v-divider class="mt-10" />

      <v-textarea
        v-model="form.poznamky"
        :disabled="form.closed"
        label="Poznámky a doplňujúce informácie"
        auto-grow
        rows="1"
      />

      <v-select
        v-model="form.nepravdive_zavadzajuce"
        v-validate="'required'"
        :disabled="form.closed"
        :items="selects.nepravdive_zavadzajuce"
        label="Nepravdivé/zavádzajúce informácie"
        name="Nepravdivé/zavádzajúce informácie"
        :error-messages="errors.collect('Nepravdivé/zavádzajúce informácie')"
        required
        append-icon="mdi-information-outline"
        @click:append="appendIconCallback('nepravdive_zavadzajuce')"
      />

      <v-divider class="mt-10" />

      <v-layout
        v-if="!form.closed"
        pt-5
      >
        <v-btn
          dark
          color="primary"
          @click="updateItem"
        >
          Uložiť
        </v-btn>
        <div class="flex-grow-1" />
        <v-btn
          dark
          color="red"
          @click="closeItem"
        >
          Uložiť a uzatvoriť
        </v-btn>
      </v-layout>
      <v-layout
        v-else
        pt-5
      >
        <div class="flex-grow-1" />
        <v-btn
          v-if="!craItem.closed"
          dark
          color="green"
          @click="openItem"
        >
          Otvoriť
        </v-btn>
      </v-layout>
    </form>

    <v-snackbar
      v-model="snackbar_saved"
      color="success"
      :timeout="3000"
    >
      Uložené
      <v-btn
        text
        @click="snackbar_saved = false"
      >
        Zavrieť
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="snackbar_error"
      color="error"
      :timeout="5000"
    >
      Chyba
    </v-snackbar>

    <v-dialog
      v-model="dialog"
      width="800px"
    >
      <tooltip-component
        :dialog_item="dialog_item"
        :on_close="closeTooltipDialog"
      />
    </v-dialog>
  </div>

  <div v-else>
    <form-skeleton-component skeleton_type="complex" />
  </div>
</template>

<script>
import Vue from "vue";
import { APIService } from "@/http/APIService.js";
import VeeValidate, { Validator } from "vee-validate";
import sk from "vee-validate/dist/locale/sk";
import { Tooltips } from "@/assets/tooltips";
import TooltipComponent from "./TooltipComponent.vue";
import FormSkeleton from "../../components/FormSkeleton.vue";

Vue.use(VeeValidate);
Validator.localize("sk", sk);

const apiService = new APIService();
const tooltips = new Tooltips();

export default {
  $_veeValidate: {
    validator: "new",
  },
  components: {
    "form-skeleton-component": FormSkeleton,
    "tooltip-component": TooltipComponent,
  },
  data: () => ({
    loading: false,
    snackbar_saved: false,
    snackbar_error: false,
    dialog: false,
    dialog_item: {
      nazov: "",
      charakteristika: [],
      zdroj: [],
      poznamka: [],
      priklad: [],
    },

    form: {
      id: null,
      expertne_posudenie: "1",
      nepravdive_zavadzajuce: "",
    },

    craItem: {},

    selects: {
      expertne_posudenie: ["malá", "stredná", "vysoká"],
      nepravdive_zavadzajuce: [
        "podľa výsledkov náhodného overenia vybraných informácii poskytovaných odsúdeným odsúdený UVIEDOL nepravdivé/zavádzajúce informácie pri hodnotení, vo vstupnom dotazníku a pri pohovoroch",
        "podľa výsledkov náhodného overenia vybraných informácii poskytovaných odsúdeným odsúdený NEUVIEDOL nepravdivé/zavádzajúce informácie pri hodnotení, vo vstupnom dotazníku a pri pohovoroch",
      ],
    },

    manual: tooltips.socialnyKurator,
  }),

  computed: {
    color() {
      if (this.form.expertne_posudenie == 0) return "grey";
      if (this.form.expertne_posudenie == 1) return "green";
      if (this.form.expertne_posudenie == 2) return "orange";
      if (this.form.expertne_posudenie == 3) return "red";
      return "grey";
    },
  },

  created() {
    this.getSocialnyKurator();
  },

  methods: {
    closeTooltipDialog() {
      this.dialog = false;
    },
    appendIconCallback(nazov) {
      this.dialog = true;
      this.dialog_item = this.manual[nazov];
    },
    clear() {
      this.form.expertne_posudenie = "1";
      this.skore = 0;
    },
    getSocialnyKurator() {
      this.loading = true;
      var numberOfItemsToLoad = 2;
      apiService.getSocialnyKurator(this.$route.params.id).then((response) => {
        this.form = response;
        numberOfItemsToLoad--;
        if (numberOfItemsToLoad == 0) {
          this.loading = false;
        }
      });
      apiService.getCraForm(this.$route.params.id).then((response) => {
        this.craItem = response;
        numberOfItemsToLoad--;
        if (numberOfItemsToLoad == 0) {
          this.loading = false;
        }
      });
    },
    updateItem() {
      apiService.updateSocialnyKurator(this.form, this.$route.params.id).then(
        () => {
          this.snackbar_saved = true;
          this.$root.$emit('ecra_part_updated');
        },
        () => {
          this.snackbar_error = true;
        }
      );
    },
    openItem() {
      apiService
        .updateSocialnyKurator(
          { id: this.form.id, closed: false },
          this.$route.params.id
        )
        .then(
          (response) => {
            this.snackbar_saved = true;
            this.form = response;
            this.$root.$emit('ecra_part_updated');
          },
          () => {
            this.snackbar_error = true;
          }
        );
    },
    closeItem() {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          if (
            confirm(
              "Naozaj chcete uložiť a uzatvoriť túto časť formulára? (Následne nebude možné už formulár upravovať)"
            )
          ) {
            this.form.closed = true;

            apiService
              .updateSocialnyKurator(this.form, this.$route.params.id)
              .then(
                (response) => {
                  this.snackbar_saved = true;
                  this.form = response;
                  this.$root.$emit('ecra_part_updated');
                },
                () => {
                  this.snackbar_error = true;
                }
              );
          }
        } else {
          alert("Všetky položky musia byť vyplnené.");
        }
      });
    },
  },
};
</script>